<template>
  <!-- 合作案例 -->
  <div class="exampleContainer">
    <div class="exampleList" v-show="!isShowList">
      <img src="./images/icon_none.png" alt="">
      <u class="noData">暂无数据</u>
    </div>
    <div class="exampleList" v-show="isShowList">
      <div class="listTop">
        <span>产品名称</span>
        <span>营销标的</span>
        <span>下单时间</span>
        <span>合同金额</span>
      </div>
      <div class="hr"></div>
      <div class="listItem" v-for="(item,i) in pageDrList" :key="i">
        <p class="title">{{item.ordertype?item.ordertype:'-'}}</p>
        <p class="title title2">{{item.yxbd?item.yxbd:'-'}}</p>
        <span class="creatTime">{{item.createdt?item.createdt:'-'}}</span>
        <span class="price">￥{{item.contractprice?item.contractprice:'-'}}</span>
        <span class="marketingData" @click="listItemClick(item.nid,i,item.ordertype)">营销数据</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cooperation",
  props:["userId", "idsInfo"],
  data(){
    return {
      darenID:'',
      // 分页
      currentPage: 1,
      //达人列表
      isShowList:false,
      pageDrList:[]
    }
  },
  computed:{
    
  },
  methods:{
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    //点击跳转
    listItemClick(nid,clickIndex,type){
      let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
      let name=window.sessionStorage.getItem('name')
      window.sessionStorage.clear()
      window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
      window.sessionStorage.setItem('name',name)
      let routeData
      if(type==="专场直播"){
        routeData = this.$router.resolve({
          path: '/drliveDetail',
          query: {
              id: nid
          }
        })
      }else if(type==="短视频一口价"){
        routeData = this.$router.resolve({
          path: '/cooperationDetail',
          query: {
              id: nid
          }
        })
      }else if(type==="短视频CPM旧"){
        routeData = this.$router.resolve({
          path: '/drcpmDetail',
          query: {
              id: nid
          }
        })
      }
      window.open(routeData.href, "_blank");


      // 合作明细 营销数据跳转埋点
      let logParams = {
        type: 6,
        plat: 2,
        ...this.idsInfo,
        tags: [{ field: "nid", value: nid}]
      }
      this.$api.setUseLog(logParams)

    }

  },
  components:{
  
  },
  watch:{
    
  },
  created(){
    this.darenID = this.$route.query.id
    if(window.sessionStorage.getItem('ksgetDrList')){
      this.pageDrList = JSON.parse(window.sessionStorage.getItem('ksgetDrList')).data.data
      if(this.pageDrList&&this.pageDrList.length!==0){
        this.isShowList = true
      }
    }else{
      this.$api.getData.getDrList('/'+this.darenID,'plat=2&page=1').then((res) => {
        window.sessionStorage.setItem('ksgetDrList',JSON.stringify(res))
        this.pageDrList = JSON.parse(window.sessionStorage.getItem('ksgetDrList')).data.data
        if(this.pageDrList&&this.pageDrList.length!==0){
          this.isShowList = true
        }
      })
    }
    
  },
  mounted() {
  }
}
</script>

<style scoped>
  .exampleContainer{
    width: 864px;
    padding: 0;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .exampleContainer .exampleList{
    width: 100%;
  }
  .exampleContainer .exampleList .noData{
    display: block;
    text-align: center;
    margin: 20px auto;
    color: #A1A1A1;
    padding-bottom: 30px;
  }
  .exampleContainer .exampleList img{
    display: block;
    margin: auto;
    padding-top: 30px;
  }
  .exampleContainer .exampleList .listItem{
    width: 100%;
    height: 94px;
    line-height: 94px;
    cursor: pointer;
  }
  .exampleContainer .exampleList .hr{
    width: 804px;
    height: 1px;
    border-bottom: 1px solid #F0F0F0;
    margin-left: 30px;
    box-sizing: border-box;
  }
  .exampleContainer .exampleList .listItem:hover{
    background: #FBFBFB;
  }
  .exampleContainer .exampleList .listItem:hover .marketingData{
    background: #FF5C00;
    border-color: #FF5C00;
    color: #fff;
  }
  .exampleList .listTop{
    width: 100%;
    overflow: hidden;
    padding-top: 10px;
    padding-left: 10px;
    box-sizing: border-box;
  }
  .exampleList .listTop span{
    float: left;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: #999;
    margin-left: 20px;
  }
  .exampleList .listTop span:nth-of-type(1){
    width: 190px;
  }
  .exampleList .listTop span:nth-of-type(2){
    width: 200px;
  }
  .exampleList .listTop span:nth-of-type(3){
    width: 78px;
  }
  .exampleList .listTop span:nth-of-type(4){
    width: 170px;
  }
  .listItem .title {
    float: left;
    width: 190px;
    height: 100%;
    margin:0 30px;
    margin-right: 20px;
    line-height: 94px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    text-align: center;
  }
  .listItem .title2 {
    width: 200px;
    margin-left: 0;
  }
  .listItem .creatTime{
    float: left;
    width: 78px;
    margin-right: 20px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333;
    text-align: center;
  }
  .listItem .creatTime:nth-of-type(2){
    margin-right: 0;
  }
  .listItem .price{
    float: left;
    width: 170px;
    font-size: 20px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #FF5C00;
    text-align: center;
  }
  .listItem .priceInfo{
    float: left;
    width: 18px;
    height: 20px;
    margin-top: 36px;
    margin-left: 80px;
    background: url("./images/icon_price.png") no-repeat center;
    background-size: contain;
  }
  .listItem .marketingData{
    float: right;
    width: 88px;
    height: 34px;
    margin-top: 30px;
    margin-right: 20px;
    background: #FFFFFF;
    border: 1px solid #F0F0F0;
    border-radius: 4px;
    line-height: 34px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #666666;
    text-align: center;
  }
  .listItem .el-button:focus, .listItem .el-button:hover{
    color:transparent;
    border-color:transparent;
    background-color:transparent;
  }
  .listItem .el-button{
    border-color: transparent;
    padding: 0;
  }
  .priceHover{
    width: 210px;
    height: 184px;
    padding: 20px;
    box-sizing: border-box;
  }
  .priceHover .priceItem{
    width: 100%;
    height: 20px;
    margin-bottom: 16px;
  }
  .priceHover .hr{
    margin-bottom: 16px;
  }
  .priceHover .priceItem span{
    float: left;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #999999;
  }
  .priceHover .priceItem i{
    float: right;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 800;
    color: #333333;
    text-align: right;
  }
  .pages {
    width: 100%;
    height: 75px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    box-sizing: border-box;
  }
  .pages .el-pagination {
    padding: 2px 0;
  }

  .pages .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #FF5C00;
    background: #FFF2EB;
  }

  .pages .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #FF5C00;
    background: #FFF2EB;
  }
  .pages>>>.el-input__inner:focus{
    border-color:rgb(250, 159, 109);
  }
  .pages>>>.el-icon{
    text-align: center;
  }
</style>